define([
    'index2024-buyChannel/component/input-attach',
    'index2024-buyChannel/api',
    'index2024-buyChannel/common/api',
    'lodash'
], function(
    InputAttach,
    Api,
    NewApi,
    _
){
    return {
        components: {
            InputAttach: InputAttach
        },
        data: function(){
            return {
                form: {},
                attachments: []
            };
        },
        methods: {
            submit: function(){
                var _this = this;
                _this.form.attch = _.chain(_this.attachments)
                    .map('uploadFilePath')
                    .join(';')
                    .value();
                var memberId = localStorage.getItem('fnjinew_memberId');
                if(memberId){
                    _this.form.memberId = memberId;
                }
                NewApi.applyInfoApi.ajax({data: JSON.stringify(_this.form)})
                    .done(function(){
                        _this.resetForm();
                        _this.attachments = [];
                        alert('提交成功');
                    });
            },
            resetForm: function(){
                this.form = {};
            }
        },
        created: function(){
            this.resetForm();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./index2024-buyChannel/mixin/form.js
// module id = 140
// module chunks = 4 5